<div class="update-password">
  <div class="container-fluid">
    <div class="row justify-content-end">
      <div class="close-btn">
        <mat-icon (click)="closeClick()" svgIcon="close"></mat-icon>
        <div class="text">ESC</div>
      </div>
    </div>
    <div class="broker-modal-content" *ngIf="!showConfirm">
      <div class="broker-modal-title">Alterar senha de acesso - Cotação</div>
      <div class="broker-modal-subtitle">
        Para garantir a segurança da conta e dos dados, recomendamos o preenchimento dos campos abaixo:
      </div>
      <div class="snack-bar-msg">
        <div #error></div>
      </div>
      <form name="form" class="form" #brokerForm="ngForm" novalidate>
        <mat-form-field class="userinput">
          <input [type]="showpassword ? 'text' : 'password'" matInput placeholder="digite sua senha"
            autocomplete="password" name="password" [(ngModel)]="model.password" #password="ngModel" required
            minlength="6" maxlength="20" (keypress)="validChar($event)" ondragstart="return false;"
            ondrop="return false;">
          <span *ngIf="model.password && model.password != ''" (click)="togglePassword()" class="showHideSuffix"
            matSuffix>{{showpassword ? 'ocultar': 'mostrar'}}</span>
          <mat-hint align="end" class="mt-1">
          </mat-hint>
          <mat-error *ngIf="password.value == '' && password.touched">Campo obrigatório</mat-error>
        </mat-form-field>
        <mat-form-field class="userinput">
          <input (keyup)="validatorPassword2(model.newPassword)" [type]="showNewPassword ? 'text' : 'password'" matInput
            placeholder="sua nova senha" autocomplete="new-password" name="newPassword" [(ngModel)]="model.newPassword"
            #newPassword="ngModel" required minlength="6" maxlength="20" (keypress)="validChar($event)"
            ondragstart="return false;" ondrop="return false;">
          <span *ngIf="model.newPassword && model.newPassword != ''" (click)="toggleNewPassword()" class="showHideSuffix"
            matSuffix>{{showNewPassword ? 'ocultar': 'mostrar'}}</span>
          <mat-hint align="end" class="mt-1">
          </mat-hint>
          <mat-error *ngIf="newPassword.value == '' && newPassword.touched || !validPass">Campo obrigatório</mat-error>
        </mat-form-field>
        <mat-form-field class="userinput">
          <input (keyup)="validatorPassword()" [type]="showConfirmPassword ? 'text' : 'password'" matInput
            placeholder="confirme sua nova senha" autocomplete="confirm-password" name="confirmPassword"
            [(ngModel)]="model.confirmPassword" #confirmPassword="ngModel" required minlength="6" maxlength="20"
            (keypress)="validChar($event)" ondragstart="return false;" ondrop="return false;">
          <span *ngIf="model.confirmPassword && model.confirmPassword != ''" (click)="toggleConfirmPassword()"
            class="showHideSuffix" matSuffix>{{showConfirmPassword ? 'ocultar': 'mostrar'}}</span>
          <mat-hint align="end" class="mt-1">
          </mat-hint>
          <mat-error *ngIf="confirmPassword.value == '' && confirmPassword.touched || !validPass">Campo obrigatório
          </mat-error>
        </mat-form-field>
        <div class="msg-error-one" *ngIf="confirmPassword && newPassword && !validPass">
          <span class="message-error">{{ errorMsg01 }}</span>
        </div>
        <div class="msg-error-two" *ngIf="!confirmPassword && !newPassword && !validPass">
          <span class="message-error">{{ errorMsg01 }}</span>
        </div>
        <div class="row complexy-password">
          <div class="col-12 bold">Caracteres permitidos: @$*</div>
          <div class="col-12 bold">Sugestão de senha:</div>
          <div class="col-6">
            <div>
              <mat-icon *ngIf="passwordComplexyLength" svgIcon="success-password"></mat-icon>
              <mat-icon *ngIf="!passwordComplexyLength" svgIcon="success-password-disable"></mat-icon>
              <span [ngClass]="{'valid': passwordComplexyLength }">Pelo menos 8 caracteres</span>
            </div>
            <div>
              <mat-icon *ngIf="passwordComplexyNumber" svgIcon="success-password"></mat-icon>
              <mat-icon *ngIf="!passwordComplexyNumber" svgIcon="success-password-disable"></mat-icon>
              <span [ngClass]="{'valid': passwordComplexyNumber }">Use números de 0-9</span>
            </div>
            <div>
              <mat-icon *ngIf="passwordComplexySpecial" svgIcon="success-password"></mat-icon>
              <mat-icon *ngIf="!passwordComplexySpecial" svgIcon="success-password-disable"></mat-icon>
              <span [ngClass]="{'valid': passwordComplexySpecial }">Inclua um caractere especial</span>
            </div>
          </div>
          <div class="col-6">
            <div>
              <mat-icon *ngIf="passwordComplexyLetterDown" svgIcon="success-password"></mat-icon>
              <mat-icon *ngIf="!passwordComplexyLetterDown" svgIcon="success-password-disable"></mat-icon>
              <span [ngClass]="{'valid': passwordComplexyLetterDown }">Use letras minúsculas (a-z)</span>
            </div>
            <div>
              <mat-icon *ngIf="passwordComplexyLetterUp" svgIcon="success-password"></mat-icon>
              <mat-icon *ngIf="!passwordComplexyLetterUp" svgIcon="success-password-disable"></mat-icon>
              <span [ngClass]="{'valid': passwordComplexyLetterUp }">Use letras maiúscula (A-Z)</span>
            </div>
          </div>
        </div>
        <div class="row strong-password" *ngIf="model.newPassword">
          <div class="col-3" *ngIf="passwordWeak" [ngClass]="{'strong' : passwordWeak}"></div>
          <div class="col-3" *ngIf="passwordWeak && passwordMedium" [ngClass]="{'strong' : passwordMedium}"></div>
          <div class="col-3" *ngIf="passwordWeak && passwordMedium && passwordGood"
            [ngClass]="{'strong' : passwordGood}"></div>
          <div class="col-3" *ngIf="passwordWeak && passwordMedium && passwordGood && passwordStrong"
            [ngClass]="{'strong' : passwordStrong}"></div>
          <div class="col-12">
            Sua senha está:
            <span class="text-weak" [ngClass]="{
              'text-strong': passwordWeak && passwordMedium && passwordGood && passwordStrong,
              'text-good': passwordWeak && passwordMedium && passwordGood,
              'text-medium':passwordWeak && passwordMedium
            }">{{
              passwordWeak && passwordMedium && passwordGood && passwordStrong ? 'Muito Forte' :
              passwordWeak && passwordMedium && passwordGood ? 'Boa' :
              passwordWeak && passwordMedium ? 'Razoável' : 'Fraca'
            }}</span>
          </div>
        </div>



        <div class="button-submit">
          <div class="button-progress">
            <div id="spinnerDiv" *ngIf="!isUserLogged && loading" [ngClass]="{ 'fadeIn': loading, 'fadeOut': !loading }"
              class="animated">
              <mat-spinner diameter="38" color="primary02"></mat-spinner>
            </div>
            <button [ngClass]="{ 'fadeIn': !loading, 'fadeOut': loading, 'error': brokerForm.form.invalid && brokerForm.touched &&
              newPassword.invalid && confirmPassword.invalid, 'success': !loading && isUserLogged }" mat-raised-button
              color="primary01" class="animated" type="submit" (click)="difusionChangePassword(model)"
              [disabled]="loading || brokerForm.form.invalid || newPassword.invalid || confirmPassword.invalid || !validPass">
              Alterar
            </button>
          </div>
        </div>

      </form>
    </div>

    <div class="broker-modal-content" *ngIf="showConfirm">
      <div class="password-success">
        <div class="broker-modal-title title">Sua senha foi alterada com sucesso!</div>
        <div class="img">
          <img src="./assets/images/svg/password-success.svg" width="115.1px" height="108.9px">
        </div>
      </div>
    </div>

  </div>
</div>
